import { render, staticRenderFns } from "./ColumnDetail.vue?vue&type=template&id=f9948a4a&scoped=true&"
import script from "./ColumnDetail.vue?vue&type=script&lang=js&"
export * from "./ColumnDetail.vue?vue&type=script&lang=js&"
import style0 from "./ColumnDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ColumnDetail.vue?vue&type=style&index=1&id=f9948a4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9948a4a",
  null
  
)

export default component.exports